import React from "react";
import { Link } from "react-router-dom";
import Swal from "sweetalert2";
import { products } from "../data/productsData";


const badgeClass = { Sale: "bg-danger", Hot: "bg-danger", New: "bg-success" };

// draws full / half / empty stars from a rating like 4.5
const renderStars = (rating) =>
  [1, 2, 3, 4, 5].map((n) => {
    let icon = "bi-star";
    if (rating >= n) icon = "bi-star-fill";
    else if (rating >= n - 0.5) icon = "bi-star-half";
    return <i key={n} className={`bi ${icon}`} />;
  });

const ProductItem = () => {
  const handleAddClick = (e, product) => {
    e.preventDefault();
    Swal.fire({
      icon: "success",
      title: "Added to Cart",
      text: `${product.name} (${product.weight}) has been added to your cart!`,
      showConfirmButton: true,
      timer: 3000,
    });
  };

  return (
    <div>
      {/* Popular Products Start */}
      <section className="my-lg-14 my-8">
        <div className="container">
          <div className="row">
            <div className="col-12 mb-6">
              <div className="section-head text-center mt-8">
                <h3 className="h3style" data-title="Popular Products">
                  Popular Products
                </h3>
                <div className="wt-separator bg-primarys"></div>
                <div className="wt-separator2 bg-primarys"></div>
              </div>
            </div>
          </div>

          <div className="row g-4 row-cols-lg-5 row-cols-2 row-cols-md-3">
            {products.map((product) => (
              <div className="col fade-zoom" key={product.id}>
                <div className="card card-product h-100">
                  <div className="card-body">
                    <div className="text-center position-relative">
                      {product.badge && (
                        <div className="position-absolute top-0 start-0">
                          <span className={`badge ${badgeClass[product.badge] || "bg-success"}`}>
                            {product.badge}
                          </span>
                        </div>
                      )}

                      <Link to={`/ProductList/ProductDetail/${product.id}`}>
                        <img
                          src={product.image}
                          alt={product.name}
                          className="mb-3 img-fluid"
                          loading="lazy"
                          style={{ height: 160, objectFit: "contain" }}
                        />
                      </Link>

                      {/* <div className="card-product-action">
                        <Link
                          to={`/ProductList/ProductDetail/${product.id}`}
                          className="btn-action"
                          title="View Details"
                        >
                          <i className="bi bi-eye" />
                        </Link>
                        <Link to="#!" className="btn-action" title="Wishlist">
                          <i className="bi bi-heart" />
                        </Link>
                      </div> */}
                    </div>

                    <div className="text-small mb-1">
                      <Link to={`/ProductList/ProductDetail/${product.id}`} className="text-decoration-none text-muted">
                        <small>{product.category}</small>
                      </Link>
                    </div>

                    <h2 className="fs-6 mb-1">
                      <Link to={`/ProductList/ProductDetail/${product.id}`} className="text-inherit text-decoration-none">
                        {product.name}
                      </Link>
                    </h2>
                    <small className="text-muted">{product.weight}</small>

                    <div className="mt-1">
                      <small className="text-warning">{renderStars(product.rating)}</small>{" "}
                      <span className="text-muted small">
                        {product.rating} ({product.reviews})
                      </span>
                    </div>

                    <div className="d-flex justify-content-between align-items-center mt-3">
                      <div>
                        <span className="text-dark">₹{product.price}</span>{" "}
                        {product.oldPrice > product.price && (
                          <span className="text-decoration-line-through text-muted small ms-1">
                            ₹{product.oldPrice}
                          </span>
                        )}
                      </div>
                      <div>
                        <Link
                          to={`/ProductList/ProductDetail/${product.id}`}
                          className="btn btn-primary btn-sm"

                        >
                          {/* <svg
                            xmlns="http://www.w3.org/2000/svg"
                            width={16}
                            height={16}
                            viewBox="0 0 24 24"
                            fill="none"
                            stroke="currentColor"
                            strokeWidth={2}
                            strokeLinecap="round"
                            strokeLinejoin="round"
                            className="feather feather-plus"
                          >
                            <line x1={12} y1={5} x2={12} y2={19} />
                            <line x1={5} y1={12} x2={19} y2={12} />
                          </svg>{" "} */}
                          View Details
                        </Link>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>
      {/* Popular Products End */}
    </div>
  );
};

export default ProductItem;